export default __webpack_public_path__ + "static/media/nfti.30786a20.png";